<!-- ip限制页面 -->
<template>
    <div class="iplimit">
        <img class="iplimit-img" src="../../assets/img/iplimit/iplimit01.png" alt="">
        <div class="iplimit-box1">
            <img class="iplimit-img2" src="../../assets/img/iplimit/iplimit02.png" alt="">
            <span class="iplimit-text">访问受限制</span>
        </div>
        <div class="iplimit-box2">
            <span>尊敬的用户，由于相关法规限制，您所在的地区无法访问，如有任何疑问，请联系客服，我们将第一时间给您回复，对您造成的不便，我们深表歉意，感谢您的理解和支持！</span>
        </div>
        <div class="iplimit-box3">
            您的IP地址: {{ip}}
        </div>
        <div class="iplimit-box4" @click="toCustomer"></div>
        <div class="backButtom" @click="backHome">
            返回首页
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            ip: '0.0.0.0',
            custommerUrl: ''
        }
    },
    created () {
        if (this.$route.query.ip) {
            this.ip = this.$route.query.ip;
            this.custommerUrl = this.$route.query.custommerUrl;
        }
    },
    methods: {
        toCustomer() {
            window.open(this.custommerUrl, "_blank");
        },
        backHome() {
            this.$router.push({
                path:'/home'
            })
        }
    }
}
</script>


<style scoped>
.iplimit {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: #ffffff;
}
.iplimit-img {
    width: 560px;
}
.iplimit-box1 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: -100px;
}
.iplimit-img2 {
    width: 60px;
    margin-right: 8px;
}
.iplimit-text {
    color: #ED8980;
    font-size: 44px;
    font-weight: 600;
}
.iplimit-box2 {
    max-width: 600px;
    padding: 20px 40px;
    box-shadow: 2px 2px 10px #eee;
    position: relative;
    top: -70px;
    color: #333;
}
.iplimit-box3 {
    font-size: 24px;
    color: #ED8980;
    position: relative;
    top: -20px;
    /* font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif */
}
.iplimit-box4 {
    width: 260px;
    height: 76px;
    background: url('../../assets/img/iplimit/pc_customer.png');
    cursor: pointer;
    margin-left: 20px;
}
.backButtom {
    width: 160px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    color: #ccc;
    font-size: 16px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 20px;
    cursor: pointer;
}
</style>